<template>
  <v-alert
    prominent
    text
    type="warning"
    v-if="getIsAdmin === true && getRecipeToConfigure.length > 0"
  >
    <v-row align="center" no-gutters>
      <span
        >Certaines recettes ont été créé dans une autre succursale. Les données
        concernant l'inventaire ont été automatiquement copié mais il se
        pourrait que des modifications soient nécessaire pour bien être adapté à
        cette succursale.</span
      >
    </v-row>
    <v-row align="center" justify="start" no-gutters class="mt-3">
      <v-btn text small color="warning" @click="showRecipes = !showRecipes"
        ><v-icon small left>fa-chevron-down</v-icon> Afficher les
        recettes</v-btn
      >
    </v-row>
    <v-menu-transition>
      <v-container v-if="showRecipes === true" style="border-left: 3px solid;">
        <v-row
          align="center"
          justify="space-between"
          no-gutters
          v-for="recipe in getRecipeToConfigure"
          :key="recipe.id"
          class="my-1"
        >
          <span>{{ recipe.nom }}</span>
          <div>
            <v-btn
              small
              text
              color="warning"
              @click="
                $router.push({
                  name: 'RecipeEditor',
                  params: { id: recipe.id }
                })
              "
              >Ouvrir</v-btn
            >
            <v-btn
              small
              text
              color="tertiary"
              class="ml-3"
              @click="dismiss(recipe)"
              >Ne pas modifier</v-btn
            >
          </div>
        </v-row>
      </v-container>
    </v-menu-transition>
  </v-alert>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
export default {
  name: "RecipeConfigurationAlert",
  computed: {
    ...mapGetters(["getIsAdmin", "getRecipes"]),
    getRecipeToConfigure() {
      return this.getRecipes.filter(
        x => x.data && x.data.need_configuration === true
      );
    }
  },
  data() {
    return {
      showRecipes: false
    };
  },
  methods: {
    async dismiss(recipe) {
      const d = {
        ...recipe
      };
      d.data.need_configuration = false;
      await api.patchRecipe(recipe.id, d);
      this.$store.dispatch("loadRecipes");
    }
  }
};
</script>

<style></style>
